import { gql } from '@apollo/client'

export const GET_LIST_SUBJECT = gql`
  query findAllSubjects($params: SubjectQueryInput!) {
    findAllSubjects(query: $params) {
      items {
        id
        tabName
        type
        slug
        platform {
          id
          title
        }
      }
    }
  }
`

export const FIND_SUBJECT_BY_PLATFORM = gql`
  query findSubjectByPlatform($platformId: String!) {
    findSubjectByPlatform(platformId: $platformId) {
      platform
      tabs {
        id
        tabName
        type
        slug
      }
    }
  }
`

export const FIND_ONE_SUBJECT = gql`
  query findOneSubject($id: String!) {
    findOneSubject(id: $id) {
      id
      tabName
      type
      slug
      platform {
        id
        slug
        title
      }
      questionBankDescription
    }
  }
`

export const UPDATE_SUBJECT = gql`
  mutation updateSubject($params: UpdateSubjectInput!) {
    updateSubject(updateSubjectInputFieldName: $params) {
      id
    }
  }
`

export const GET_PLATFORMS_WITH_SUBJECTS = gql`
  query findAllWithSubjectsTabs {
    findAllWithSubjectsTabs(withHiddenTabs: true) {
      id
      title
      slug
      shortDescription
      description
      isActive
      category
      subjects {
        id
        icon
        tabName
        type
        slug
        questionBankDescription
        classroomTab {
          id
          tabName
          tabEnum
          order
          isHidden
        }
      }
      studyTools {
        id
        title
        link
        icon
        order
      }
      order
    }
  }
`

export const UPDATE_CLASSROOM_TAB = gql`
  mutation updateClassRoomTab($params: UpdateClassroomTabInput!) {
    updateClassRoomTab(updateClassRoomTabInput: $params) {
      id
      tabName
      tabEnum
      order
      isHidden
    }
  }
`
